export default "__VITE_ASSET__0bf5f7bd__"